import React from "react";
import { Link } from "react-router-dom";
import { Phone, Mail, MessageCircle } from "lucide-react";
import { useApp } from "@/context/AppContext";
import { Toranam } from "@/components/Ornaments";

export default function Footer() {
  const { t, settings } = useApp();
  const phone = settings?.helpline_phone || "9603333685";
  const founder = settings?.founder_name || "బాచరాజు వరుణ్ కుమార్";
  const email = settings?.support_email || "contact@devalayabandham.com";
  return (
    <footer className="mt-16 bg-maroon text-parchment">
      <Toranam className="rotate-180" />
      <div className="max-w-7xl mx-auto px-6 py-12 grid md:grid-cols-4 gap-8">
        <div className="md:col-span-2">
          <div className="font-display text-2xl font-extrabold text-marigold" data-testid="footer-brand-name">🔔 ArchakaVeda</div>
          <div className="text-sm text-marigold/80 font-telugu mb-2">{t("site_name")} · archakaveda.com</div>
          <p className="text-sm text-parchment/80 font-telugu max-w-sm">{t("footer_tagline")}</p>
          <p className="mt-4 text-sm font-telugu"><span className="text-marigold">వ్యవస్థాపకులు:</span> {founder}</p>
        </div>
        <div>
          <h4 className="text-marigold font-semibold mb-3 font-telugu">త్వరిత లింకులు</h4>
          <ul className="space-y-2 text-sm font-telugu text-parchment/85">
            <li><Link to="/temples" data-testid="footer-temples" className="hover:text-marigold">{t("nav_temples")}</Link></li>
            <li><Link to="/archakas" data-testid="footer-archakas" className="hover:text-marigold">{t("nav_archakas")}</Link></li>
            <li><Link to="/post-vacancy" data-testid="footer-post" className="hover:text-marigold">{t("nav_post")}</Link></li>
            <li><Link to="/about" data-testid="footer-about" className="hover:text-marigold">{t("nav_about")}</Link></li>
          </ul>
        </div>
        <div>
          <h4 className="text-marigold font-semibold mb-3 font-telugu">{t("nav_contact")}</h4>
          <ul className="space-y-2 text-sm text-parchment/85">
            <li className="flex items-center gap-2"><Phone className="w-4 h-4 text-marigold" /><a href={`tel:${phone}`} className="hover:text-marigold">{phone}</a></li>
            <li className="flex items-center gap-2"><MessageCircle className="w-4 h-4 text-marigold" /><a href={`https://wa.me/91${phone}`} target="_blank" rel="noreferrer" className="hover:text-marigold">WhatsApp</a></li>
            <li className="flex items-center gap-2"><Mail className="w-4 h-4 text-marigold" /><a href={`mailto:${email}`} className="hover:text-marigold break-all">{email}</a></li>
          </ul>
        </div>
      </div>
      <div className="border-t border-parchment/20 py-4 text-center text-xs text-parchment/60 font-telugu">
        © {new Date().getFullYear()} ArchakaVeda · {t("site_name")} · సర్వం శ్రీ కృష్ణార్పణమస్తు 🙏
      </div>
    </footer>
  );
}
